query allExtCompetitions(
  $first: Int,
  $offset: Int,
  $filter: CompetitionMappingFilter,
  ) {
  allCompetitionMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      regionMapping {
        extRef
        mappingType
        mappingId
        feed
      }
      mappedEntity {
        competitionName
        source
        competitionId
      }
    }
    totalCount
  }
}
